import PropTypes from 'prop-types';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Icon, PlainButton, orange, tokens } from 'components/v3';
import { ORANGE } from './constants';
import { toggleTip } from './tipBus';

// A "?" next to a dialog label (Columns → "View name", Export → "Fields").
// Hovering shows its help tip like any other; a click or tap pins it open
// (works on touch screens) and a second one closes it. It always shows,
// even with Help tips switched off.

const Button = styled(PlainButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: -3px 0 -3px 4px;
  border-radius: 50%;
  color: ${({ $t }) => $t.faint};
  cursor: help;
  vertical-align: middle;
  letter-spacing: 0;
  transition: color 150ms ease, background 150ms ease;

  &:hover,
  &:focus-visible {
    color: ${ORANGE};
    background: ${orange(0.12)};
  }
`;

const InfoTip = ({ title, text, side, size }) => {
  const t = tokens(useTheme());
  return (
    <Button
      $t={t}
      data-tip-info=""
      data-tip-pin=""
      data-tip-title={title || undefined}
      data-tip={text || undefined}
      data-tip-side={side || undefined}
      aria-label={`About ${title || 'this'}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleTip(e.currentTarget);
      }}
    >
      <Icon name="circle-help" size={size} />
    </Button>
  );
};

InfoTip.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  side: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  size: PropTypes.number,
};

InfoTip.defaultProps = {
  title: null,
  text: null,
  side: null,
  size: 14,
};

export default InfoTip;
